<template>
  <div id="med" class="pb-2">
    <AppNavbar />

    <div v-if="benutzer && benutzer.funktionen.gesundheit == 1">
      <GesundheitHeader />

      <b-container>
        <div v-if="geraete.length > 0">
          <div v-if="sigfoxStatus.gettingSigfoxDataById" class="text-center mt-5">
            <b-spinner variant="primary" type="grow"></b-spinner>
          </div>
          <div v-else>
            <b-card v-for="geraet in geraete" :key="geraet.id" class="mb-2">
              <b-row>
                <b-col cols="12" sm="6" class="text-left">
                  <p><strong>Name: </strong>{{geraet.geraetekennung}}</p>
                  <p><strong>ID: </strong>{{geraet.sigfoxDeviceId}}</p>
                </b-col>

                <b-col cols="12" sm="6" class="text-left">
                  <p>Ihnen stehen täglich 4 Positionsabfragen zur Verfügung!</p>
                  <p><strong>Verbleibende Abfragen am {{getGeraetLastPositionRequestDate()}}:</strong> {{ 4 - geraet.anzahlPositionAbfragen}}</p>
                  <b-button variant="primary" class="mb-3" @click="loadNewPosition(geraet.sigfoxDeviceId)" :disabled="geraet.anzahlPositionAbfragen >= 4"><font-awesome-icon icon="sync-alt"/> Position aktualisieren</b-button>
                  <div v-if="sigfoxStatus.gettingSigfoxData">
                    <b-spinner variant="primary" type="grow" class="align-center"></b-spinner>
                  </div>
                  <div v-else-if="geraet.sigfoxPositionId == null" >
                    <b-alert show variant="danger">Es stehen keine Positionsdaten zur Verfügung</b-alert>
                  </div>
                  <div v-else>
                    <p><strong>Letzte bekannte Position: </strong>{{getLastPositionTime(geraet.sigfoxDeviceId)}} Uhr</p>
                    <a
                      :href="getLastPositionUrl(geraet.sigfoxDeviceId)"
                      target="_blank"
                      class="btn btn-primary text-white"
                    >Position auf Karte anzeigen</a>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </div>
          
        </div>
        <div v-else>
          <b-alert show variant="info">Es wurden keine Geräte gefunden.</b-alert>
        </div>

        <div class="py-3 mt-3">
          <b-container>
            <b-button variant="link" @click="abmelden()" class="p-0 pr-1">Abmelden</b-button>|
            <a href="https://www.htwsaar.de/impressum-und-datenschutz">Impressum und Datenschutz</a>
          </b-container>
        </div>
      </b-container>

      <!-- <b-container>
        <b-row>
          <b-col>
            <b-button v-b-modal.geraetNeuAnlegen variant="primary" class="mx-2 mb-5 float-right"><font-awesome-icon icon="plus"/> Neues Gerät</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-left">
            <GeraeteTabelle @updGeraetToast="makeToast"/>
          </b-col>
        </b-row>
      </b-container> -->


      <!-- Geraet hinzufügen  Modal -->
      <!-- <b-modal id="geraetNeuAnlegen" title="Neues Gerät hinzufügen" size="lg" header-bg-variant="primary" header-text-variant="white" hide-footer>
        <GeraetNeuAnlegen @creatGeraetToast="makeToast"/>
      </b-modal> -->
    </div>

    <b-container v-else class="py-5 headSpace">
      <b-alert variant="danger" class="mt-4" show>Diese Seite steht dir nicht zur Verfügung</b-alert>
    </b-container>
  </div>
</template>

<script>
import AppNavbar from '@/components/Nav/AppNavbar'
import GesundheitHeader from '../Content/GesundheitHeader'
// import GeraeteTabelle from '../Content/GeraeteTabelle'
// import GeraetNeuAnlegen from '../Content/GeraetNeuAnlegen'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'


export default {
  name: 'Home',
  components: {
    AppNavbar,
    GesundheitHeader,
    // GeraeteTabelle,
    // GeraetNeuAnlegen
  },
  computed: mapGetters(['benutzer', 'geraete', 'sigfox', 'sigfoxStatus', 'geraetetypen']),
  methods: {
    ...mapActions(['fetchBenutzerGeraete', 'fetchGeraetetypen', 'fetchSigfoxData', 'fetchSigfoxDataById', 'updGeraet', 'abmelden']),
    getLastPositionUrl (sigfoxDeviceId) {
      if (this.sigfox[sigfoxDeviceId]) {
        const data = this.sigfox[sigfoxDeviceId]
        return `https://www.google.com/maps/place/${data.lat}N,${data.lng}E`;
      }
    },
    getLastPositionTime (sigfoxDeviceId) {
      if (this.sigfox[sigfoxDeviceId]) {
        const data = this.sigfox[sigfoxDeviceId]
        var dataSavedTime = moment(moment(data.aDate).subtract(data.fix, "minutes").toDate())

        if (data.fix === 255) return "vor dem " + dataSavedTime.format("DD.MM.YYYY HH:mm")
        else return "vom " + dataSavedTime.format("DD.MM.YYYY HH:mm")
      }
    },
    getGeraetLastPositionRequestDate() {
      return moment(this.benutzer.letztePositionAbfrage).format("DD.MM.YYYY")
    },
    loadNewPosition(deviceId) {
      this.fetchSigfoxData(deviceId)
        .then(() => {
          const toastData = {
            title: "Position aktualisiert",
            msg: "Neue Positionsdaten stehen zur Verfügung",
            variant: "success"
          };

          if (this.sigfoxStatus.msg) {
            toastData.title = this.sigfoxStatus.msg
            toastData.msg = " "
            toastData.variant = "info"
          }

          if (this.sigfoxStatus.errMsg) {
            toastData.title = "Es ist etwas schief gelaufen.";
            toastData.msg = "Es ist ein unbekannter Fehler aufgetreten";
            toastData.variant = "danger";
          }

          this.makeToast(toastData)
        })
    },
    // updGeraet (geraet) {
    //   this.geraet = geraet
    //   this.$bvModal.show(`geraetBearbeiten`);
    // },
    makeToast (toast) {
      this.$bvToast.toast(toast.msg, {
        title: toast.title,
        toaster: 'b-toaster-bottom-full',
        variant: toast.variant,
        autoHideDelay: 7000,
        appendToast: true,
        solid: true
      })
    }
  },
  mounted () {
    // this.fetchGeraetetypen();
    this.fetchBenutzerGeraete()
    .then(() => {
      this.fetchSigfoxDataById()
    })
    .then(() => {
      if (this.geraete.length > 0) {
        var today = (new Date(Date.now())).setHours(0,0,0,0)

        this.geraete.forEach(geraet => {
          var letztePositionsabfrage = (new Date(geraet.letztePositionsabfrage)).setHours(0,0,0,0)
          if (letztePositionsabfrage < today) {
            geraet.anzahlPositionAbfragen = 0
            this.updGeraet(geraet)
          }
        })
      }
    })
  }
}
</script>

<style scoped>
.headSpace {
  margin-top: 6em;
}
</style>